import React from 'react';
import { withRouter } from 'react-router-dom';
import { OptionsSection, SearchInput } from './MenuStyles';
import Transition from 'react-transition-group/Transition';
import { BodyScroll } from '../Utils';

class MenuComponent extends React.Component {
  state = {
    string: ''
  };

  timeout = null;

  handleChange = e => {
    const { history } = this.props;
    const value = e.target.value;
    this.setState({ string: value }, () => {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        BodyScroll(false);
        history.push(`/search?content=${value}`);
      }, 1000);
    });
  };

  render() {
    const { show } = this.props;
    const { string } = this.state;
    return (
      <Transition
        timeout={{ enter: 0, exit: 200 }}
        in={show}
        unmountOnExit
        mountOnEnter
      >
        {state => (
          <OptionsSection state={state}>
            <SearchInput
              type="text"
              value={string}
              placeholder="Search"
              onChange={this.handleChange}
            />
          </OptionsSection>
        )}
      </Transition>
    );
  }
}

export default withRouter(MenuComponent);



// WEBPACK FOOTER //
// ./src/components/Menu/MenuSearch.js